export const sports = ['Fútbol', 'Hockey', 'Basquet', 'Padel', 'Voley', 'Basquet'];

export const standings = [
  { pos: '01', team: 'Astro Lions', pj: 12, pg: 10, pe: 1, pp: 1, gf: 34, gc: 12, pts: 31 },
  { pos: '02', team: 'Night Vipers', pj: 12, pg: 9, pe: 2, pp: 1, gf: 28, gc: 15, pts: 29 },
];

export const topPlayers = [
  { name: 'Carlos Mendez', points: 24, fill: '95%' },
  { name: 'Lucia Ruiz', points: 21, fill: '83%' },
];
